// extracted by mini-css-extract-plugin
export var paginationContainer = "_94-0";